import { render, staticRenderFns } from "./ComputerSalesProgramsIndex.vue?vue&type=template&id=76964587"
import script from "./ComputerSalesProgramsIndex.vue?vue&type=script&lang=js"
export * from "./ComputerSalesProgramsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports